import { combineReducers } from 'redux'

import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import { IJackpotsState } from '../types'
import * as actions from '../actions'

export default combineReducers<IJackpotsState['communications']>({
  getJackpotList: makeCommunicationReducer(actions.getJackpotList),
})
